import type { EntrySource } from './types';

import { ENTRY_SOURCE_KEY, SOURCE_RECORDING } from './constants';

export const getLocalEntrySource = (): EntrySource | null => {
  try {
    const raw = localStorage.getItem(ENTRY_SOURCE_KEY);
    if (raw === SOURCE_RECORDING) return 'recording';
    return null;
  } catch {
    return null;
  }
};

export const setLocalEntrySource = (source: EntrySource): void => {
  try {
    localStorage.setItem(ENTRY_SOURCE_KEY, source);
  } catch {
    /* no-op: storage unavailable */
  }
};

export const clearEntrySource = (): void => {
  try {
    localStorage.removeItem(ENTRY_SOURCE_KEY);
  } catch {
    /* no-op: storage unavailable */
  }
};
